// removed by extract-text-webpack-plugin
module.exports = {"sapcnqr-badge":"sapcnqr-badge-72d31c","sapcnqr-badge--muted":"sapcnqr-badge--muted-195cac"};